module.exports = __webpack_public_path__ + "img/dne_app.f352a6b6.png";